import { render, staticRenderFns } from "./otp-countdown.vue?vue&type=template&id=2cbcc3c0"
import script from "./otp-countdown.vue?vue&type=script&lang=js"
export * from "./otp-countdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports